export const instructionData=`<ul>
<li>Let the robot come to a halt at your selected drop location.</li>
<li>At the Front Top of the robot, you will see there’s a small touchscreen.</li>
<li>Enter the ${sessionStorage.getItem("pin")?.length ?? 4}-digit PIN for your order to open the cabin containing your order.</li>
<li>Pick your order from the cabin and close the cabin.</li>
</ul>
`